import { JwtAxios } from '@/packaging';

export const marketApi = {
  async MarketLoginCheck(id, model) {
    const responseModel = await JwtAxios.post(`/Market/MarketLoginCheck?connectionId=${id}`, model);
    return responseModel;
  },
  async DoProductUpload(id, model) {
    const responseModel = await JwtAxios.post(`/Market/DoProductUpload?id=` + id, model);
    return responseModel;
  },
  async DoProductUploadByCollectGuids(id, model) {
    const responseModel = await JwtAxios.post(`/Market/DoProductUploadByCollectGuids?id=` + id, model);
    return responseModel;
  },
  async UploadProduct(id, model) {
    const responseModel = await JwtAxios.post(`/Market/UploadProduct?id=` + id, model);
    return responseModel;
  },
  async DoMarketLogin(id, body) {
    const responseModel = await JwtAxios.post(`/Market/DoMarketLogin?connectionId=${id}`, body);
    return responseModel;
  },
  async CheckMarketUpload(id, body) {
    const responseModel = await JwtAxios.post(`/Market/CheckMarketUpload?connectionId=${id}`, body);
    return responseModel;
  },
  async InsertCollectMarketProducts(id, body){
    const res = await  JwtAxios.post(`/Market/InsertCollectMarketProducts?id=${id}`, body);
    return res;
  },
  async GetBulkMarketGoodsList(id, body) {
    const responseModel = await JwtAxios.post(`/MarketProduct/GetBulkMarketGoodsList`, body);
    return responseModel;
  },
  async InsertAutotCollectMarketProducts(body) {
    const responseModel = await JwtAxios.post(`/Market/InsertAutotCollectMarketProducts`, body);
    return responseModel;
  },
  async GetAutoCollectMarketProducts(marketgubun, marketId, productType) {
    const responseModel = await JwtAxios.get(`/market/GetAutoCollectMarketProducts?marketgubun=${marketgubun}&marketId=${marketId}&producttype=${productType}`);
    return responseModel;
  },
  async GetSheinInfo(keyword = '', marketAccount = '') {
    const url = `/Market/GetSheinInfo?keyword=${encodeURIComponent(keyword)}&marketAccount=${encodeURIComponent(marketAccount)}`;
    const responseModel = await JwtAxios.get(url);
    return responseModel;
  },
  async GetProductInfo(id) {
    const url = `/Market/GetProductInfo?id=${encodeURIComponent(id)}`;
    const responseModel = await JwtAxios.get(url);
    return responseModel;
  },
  async GetProductPriceBreakdown(id) {
    const url = `/Market/GetProductPriceBreakdown?id=${encodeURIComponent(id)}`;
    const res = await JwtAxios.get(url);
    return res;
  },
  async GetDomesinEtc(id) {
    const url = `/Market/GetDomesinEtc?id=${encodeURIComponent(id)}`;
    const res = await JwtAxios.get(url);
    return res;
  },
  async GetSheinProductAttributes(categoryCode = '', marketAccount = '') {
    const url = `/Market/GetSheinProductAttributes?categoryCode=${encodeURIComponent(categoryCode)}&marketAccount=${encodeURIComponent(marketAccount)}`;
    const responseModel = await JwtAxios.get(url);
    return responseModel;
  },
  async GetSheinPrice(id) {
    const url = `/Market/GetSheinPrice?id=${encodeURIComponent(id)}`;
    const responseModel = await JwtAxios.get(url);
    return responseModel;
  },
    async SaveSheinAdditionalInfo(id, body) {
      const url = `/Market/SaveSheinAdditionalInfo?id=${encodeURIComponent(id)}`;
      const res = await JwtAxios.post(url, body);
      return res;
    },
  async SaveDomesinEtc(id, domesinEtc) {
    const url = `/Product/SaveDomesinEtc?id=${encodeURIComponent(id)}`;
    const res = await JwtAxios.post(url, domesinEtc);
    return res;
  },
  async SaveCoupangEtc(id, coupangEtc) {
    const url = `/Product/SaveCoupangEtc?id=${encodeURIComponent(id)}`;
    const res = await JwtAxios.post(url, coupangEtc);
    return res;
  },
  async PreviewCoupangAttributes(id, coupangEtc) {
    const url = `/Product/PreviewCoupangAttributes?id=${encodeURIComponent(id)}`;
    const res = await JwtAxios.post(url, coupangEtc);
    return res;
  },
  async GetCoupangEtc(id) {
    const url = `/Product/GetCoupangEtc?id=${encodeURIComponent(id)}`;
    const res = await JwtAxios.get(url);
    return res;
  },
  async SaveEbayEtc(id, ebayEtc) {
    const url = `/Product/SaveEbayEtc?id=${encodeURIComponent(id)}`;
    const res = await JwtAxios.post(url, ebayEtc);
    return res;
  },
  async SaveSmartStoreEtc(id, smartStoreEtc) {
    const url = `/Product/SaveSmartStoreEtc?id=${encodeURIComponent(id)}`;
    const res = await JwtAxios.post(url, smartStoreEtc);
    return res;
  },
  async GetSmartStoreEtc(id) {
    const url = `/Product/GetSmartStoreEtc?id=${encodeURIComponent(id)}`;
    const res = await JwtAxios.get(url);
    return res;
  },
  async GetSheinAccounts() {
    const url = `/Market/GetSheinAccounts`;
    return await JwtAxios.get(url);
  },
};
